const ADD_PRODUCT_CURRENCY = "ADD_PRODUCT_CURRENCY";
const UPDATE_PRODUCT_CURRENCY = "UPDATE_PRODUCT_CURRENCY";
const DELETE_PRODUCT_CURRENCY = "DELETE_PRODUCT_CURRENCY";
const PRODUCT_CURRENCYS = "PRODUCT_CURRENCYS";
const ADD_PRODUCT_CURRENCY_ERROR = "ADD_PRODUCT_CURRENCY_ERROR";
const PRODUCT_CURRENCY_DETAILS = "PRODUCT_CURRENCY_DETAILS";


export {
	ADD_PRODUCT_CURRENCY,
	UPDATE_PRODUCT_CURRENCY,
	DELETE_PRODUCT_CURRENCY,
	PRODUCT_CURRENCYS,
	ADD_PRODUCT_CURRENCY_ERROR,
	PRODUCT_CURRENCY_DETAILS,
};
